import { BaseDto } from "@/shared/dtos/base-dto";
import { columna } from "./columna";
import { pantalla_lista } from "./pantalla_lista";

export class pantalla_modo_lista extends BaseDto {
  public pantalla!: pantalla_lista;
  public columnas!: columna[];
}